import { ADVISOR_SETTINGS_RECEIVED, ADVISOR_DETAILS_RECEIVED } from './types'
import api from 'api' 

// redux actions
export const advisorSettingsReceived = settings => ({
  type: ADVISOR_SETTINGS_RECEIVED,
  settings: settings
})

export const advisorDetailsReceived = details => ({
  type: ADVISOR_DETAILS_RECEIVED,
  details: details
})

// thunk actions
export const getAdvisorSettings = () => dispatch => 
api.bmc.advisor.getAdvisorSettings().then(settings => {
  if (!!settings.UserCategories) {
    settings.UserCategories = JSON.parse(settings.UserCategories)
  }
  if (!!settings.Address) {
    settings.Address = JSON.parse(settings.Address)
  }
  dispatch(advisorSettingsReceived(settings))
})

export const saveAdvisorSettings = (settings) => dispatch => 
  api.bmc.advisor.postAdvisorSettings(settings).then(settings => {
    dispatch(advisorSettingsReceived(settings))
  })

export const getAdvisorDetails = () => dispatch => 
  api.bmc.advisor.getAdvisorDetails().then(details => {
    dispatch(advisorDetailsReceived(details))
  })
  
export const saveAdvisorDetails = (data) => dispatch =>
  api.bmc.advisor.saveAdvisorDetails(data).then(details => {
    dispatch(advisorDetailsReceived(details))
  })
  